var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Phone",
    clipPath: "url(#clip0_22_8901)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "phone--android-phone-mobile-device-smartphone-iphone"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13.1199 32.4551C11.5832 33.4459 9.75212 33.8774 7.93464 33.6771C6.11716 33.4767 4.42405 32.6568 3.13995 31.3551L2.01745 30.2601C1.5253 29.7566 1.24976 29.0804 1.24976 28.3763C1.24976 27.6723 1.5253 26.9961 2.01745 26.4926L6.78245 21.7751C7.28175 21.2845 7.95373 21.0097 8.6537 21.0097C9.35367 21.0097 10.0256 21.2845 10.5249 21.7751C11.0285 22.2672 11.7046 22.5428 12.4087 22.5428C13.1128 22.5428 13.7889 22.2672 14.2924 21.7751L21.7749 14.2926C22.0246 14.0465 22.2229 13.7532 22.3582 13.4299C22.4935 13.1065 22.5632 12.7594 22.5632 12.4088C22.5632 12.0583 22.4935 11.7112 22.3582 11.3878C22.2229 11.0644 22.0246 10.7712 21.7749 10.5251C21.2844 10.0258 21.0095 9.35382 21.0095 8.65385C21.0095 7.95387 21.2844 7.2819 21.7749 6.7826L26.5174 2.0426C27.021 1.55045 27.6971 1.2749 28.4012 1.2749C29.1053 1.2749 29.7814 1.55045 30.2849 2.0426L31.3825 3.1676C32.6825 4.45169 33.5012 6.14399 33.7011 7.96036C33.9009 9.77673 33.4698 11.6066 32.4799 13.1426C27.3158 20.7546 20.7446 27.3096 13.1199 32.4551Z",
    stroke: "#9B9B9B",
    strokeWidth: 1.71429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_22_8901"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 35,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/Phone.7a6a25172cfaa066f66baca386448788.svg";
export { ForwardRef as ReactComponent };